import { render, staticRenderFns } from "./SkillDetails.vue?vue&type=template&id=5c884f03&"
import script from "./SkillDetails.vue?vue&type=script&lang=js&"
export * from "./SkillDetails.vue?vue&type=script&lang=js&"
import style0 from "./SkillDetails.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports